import * as React from 'react'

function SvgFunMinus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18 13H6a1 1 0 110-2h12a1 1 0 110 2" />
    </svg>
  )
}

export default SvgFunMinus
